import { apiConfig } from "../config";
import { start_loader, stop_loader } from "../util";
import { apiCommonCall } from "./api-call";
import { generateReviewList } from "./genrate-review-list";
import { defaultReviewImg } from "./load-default-review-image";

let pageReviewNumber = 1;
let pageReviewSize = 10;
let starRating = 5;

export function generateReviewFooter(totalCount:any){
    return `<div class="reviews-footer">
                <div class="pagination-controls pagination_sec">
                  <ul class="pagination">
                  </ul>
                </div>
                <div class="totalReview">
                    <p>Total number of ${starRating} star reviews : <span>${totalCount.toLocaleString()}</span></p>
                </div>
            </div>`
}


export function reviewPagination(sectionCount:any){
    let pageCount =  sectionCount / pageReviewSize;
    let separatorAdded:Boolean = false;
    render();
    function isPageInRange( pageReviewNumber:any, index:any, maxPages:any, pageBefore:any, pageAfter:any){
        if (index <= 1){
            return true;
        }
        if (index >= maxPages - 2){
            return true;
        }
        if (index >= pageReviewNumber - pageBefore && index <= pageReviewNumber + pageAfter) {
            return true;
        }
    }
    function render(){
        $(".reviews-footer .pagination").empty();
        $(".reviews-footer ul.pagination").prepend('<li class="page-item backLinkBtn"><a class="page-link" href="#"><span class="back">Back</span></a></li>');
        for(let i = 0 ; i<pageCount;i++){
                if ( isPageInRange( pageReviewNumber, i, pageCount, 2, 2 ) ) {
                    $(".reviews-footer ul.pagination").append('<li class="page-item"><a href="#" class="page-link pagingNumber"  data-page='+(i+1)+'>'+(i+1)+'</a></li> ');
                    separatorAdded = false;
                }else{
                    if (!separatorAdded) {
                        $(".reviews-footer ul.pagination").append('<li class="page-item"> <a class="page-link" href="#"> [...] </a> </li>');
                        separatorAdded = true;
                    }    
                }
        }
        $(".reviews-footer ul.pagination").append('<li class="page-item nextLinkBtn"> <a href="#" class="page-link"> <span class="next">Next</span> </a></li>');
        if(pageReviewNumber == 1){
            $('.backLinkBtn').addClass('disabled');
        }
        if(pageReviewNumber == Math.ceil(pageCount)){
            $('.nextLinkBtn').addClass('disabled');
        }
        $('a[data-page='+pageReviewNumber+']').addClass('active');
        $('a[data-page='+pageReviewNumber+']').parent().addClass("disabled");

        $(".reviews-footer li a.pagingNumber").click(function(this:any, e:any) {
            e.preventDefault();
            pageReviewNumber = parseInt($(this).attr('data-page'));
            updateReviewUrl(pageReviewNumber);
            render();
        });

        $('.reviews-footer li.nextLinkBtn a').on('click',function(e){
            e.preventDefault();
            pageReviewNumber++;
            updateReviewUrl(pageReviewNumber);
            render();
            
        });
        $('.reviews-footer li.backLinkBtn a').on('click',function(e){
            e.preventDefault();
            pageReviewNumber--;
            updateReviewUrl(pageReviewNumber);
            render();
        });
    }
}

function updateReviewUrl (pageNumber:any){
    let generateReviewArray:any=[];
    let afterCom = window.location.href.split('.com')[1];
            let countryId =  afterCom.split('/')[1].replace(/[^a-zA-Z ]/g, "") === "ca" ? 2 : 1;
    let concept_id = localStorage.getItem('brand_c_id');
    let franchiseWebLocationId = localStorage.getItem('franchiseWeblocation_id');
    let url = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&CountryId=${countryId}&StarRating=${starRating}&PageNumber=${pageNumber}&PageSize=${pageReviewSize}`;
    if(franchiseWebLocationId){
        url = `${apiConfig.reviewaggregates}&ConceptId=${concept_id}&franchiseWebLocationId=${franchiseWebLocationId}&CountryId=${countryId}&StarRating=${starRating}&PageNumber=${pageNumber}&PageSize=${pageReviewSize}`;
    }
    start_loader();
    apiCommonCall(url,function(result:any){
        stop_loader();
        if(!result?.length){
            showNoReviewPage();
            return;
        }
        hideNoReviewPage();
        result.forEach(function(item:any){
            generateReviewArray.push(generateReviewList(item));
        })
        $('.customer-review-list .reviews').html(generateReviewArray);
        $('.customer-review-list .reviews-footer').html(generateReviewFooter(result[0]?.grandTotal));
        reviewPagination(result[0]?.grandTotal);
        defaultReviewImg();
    },function (data:any, status:any){
        stop_loader();
        showNoReviewPage();
        if(status == "error"){
        }
    });
}

$(function () {
    // Toggle popover visibility on button click using event delegation
    $(document).on('click', '#popoverBtn, #starsDisplay', function (event) {
        event.stopPropagation(); // Prevent event from bubbling up to the document
        $('#popover').toggleClass('hidden');
        $('#downArrow').toggleClass('hidden');
        $('#upArrow').toggleClass('hidden');
    });

    // Handle rating form changes using event delegation
    $(document).on('change', '#ratingForm input[name="rating"]', function () {
        const selectedRating = parseInt($(this).val(), 10);
        $('#popover').addClass('hidden');
        $('#downArrow').removeClass('hidden');
        $('#upArrow').addClass('hidden');
        $('#ratingText').text('Showing:')
            .removeClass('ratings-text')
            .addClass('showing-text');
        $('#resetLink').removeClass('hidden').addClass('reset-text');
        $('#ratingsInfo').removeClass('ratings-info').addClass('hidden');
        updateStarsDisplay(selectedRating);
    });

    // Reset ratings to default
    $(document).on('click', '#resetLink', function () {
        starRating = 5;
        $('#resetLink').addClass('hidden');
        $('#downArrow').removeClass('hidden');
        $('#upArrow').addClass('hidden');
        updateStarsDisplay(starRating);

        $('#ratingForm input[name="rating"]').prop('checked', false);
        $('#ratingsInfo').removeClass('hidden').addClass('ratings-info');
        $('#ratingText').text(sessionStorage.getItem('overallRating'))
            .removeClass('showing-text')
            .addClass('ratings-text');
    });

    // Update stars display dynamically
    function updateStarsDisplay(rating: number) {
        $('#starsDisplay').empty();
        Array.from({ length: rating }, () =>
            $('<span>').addClass('star full mr-1').html('&#9733;')
        ).forEach(star => $('#starsDisplay').append(star));
        starRating = rating; // Assign rating
        pageReviewNumber = 1
        updateReviewUrl(pageReviewNumber); // Call the review update logic
    }

    // Close popover when clicking outside
    $(document).on('click', function (event) {
        if (!$('#popover').is(event.target) && !$(event.target).is('#popoverBtn, #starsDisplay') &&
            $('#popover').has(event.target).length === 0) {
            if (!$('#popover').hasClass('hidden')) {
                $('#popover').addClass('hidden');
                $('#downArrow').removeClass('hidden');
                $('#upArrow').addClass('hidden');
            }
        }
    });
});

function showNoReviewPage(){
    $('.customer-review-list').hide();
    $('.no-review-section').show();
    if(!$('.no-review-section .no-review-main').length){
        addNoReviewSectionContent();
    }
}

function hideNoReviewPage(){
    $('.customer-review-list').show();
    $('.no-review-section').hide();
}

function addNoReviewSectionContent(){
    const noReviewSection = document.querySelector('.no-review-section');
    // Create the HTML content to be added
    const htmlContent = `
        <div class="container">
            <div class="no-review-main">
                <svg class="search-icon" xmlns="http://www.w3.org/2000/svg" xml:space="preserve" viewBox="0 0 512.005 512.005">
                    <path d="m505.749 475.587-145.6-145.6c28.203-34.837 45.184-79.104 45.184-127.317C405.333 90.926 314.41.003 202.666.003S0 90.925 0 202.669s90.923 202.667 202.667 202.667c48.213 0 92.48-16.981 127.317-45.184l145.6 145.6c4.16 4.16 9.621 6.251 15.083 6.251s10.923-2.091 15.083-6.251c8.341-8.341 8.341-21.824-.001-30.165zM202.667 362.669c-88.235 0-160-71.765-160-160s71.765-160 160-160 160 71.765 160 160-71.766 160-160 160z"/>
                </svg> 
                <h2 class="no-review-heading">No reviews added yet.</h2>
                <div class="no-review-text">
                    <p>Sorry, no reviews match your current selections.</p>
                    <p>Try resetting or changing the rating.</p>
                </div>
            </div>
        </div>`;
    // Add the HTML to the section
    noReviewSection.innerHTML = htmlContent;
}